import { HttpBackend, HttpEvent, HttpRequest, HttpResponse, HttpStatusCode, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Observable, Observer } from 'rxjs';
import { getValueProperty } from "./functions.helpers";
/*import * as originalFetch from 'isomorphic-fetch';
var fetch = require('fetch-retry')(originalFetch);*/


/**
 * Clase encargada de realizar las peticiones http (Fetch Api) a 
 * los diferentes servicios api expuestos por el backend
 */
export class HttpFetchBackend implements HttpBackend {

    /**
     * Realiza el procesamiento de la petision
     * @param req Solicitud enviada por el cliente
     * @returns Observable<HttpEvent> Resultado de la petición, 
     * puede ser de tipo HttpResponse para ejecuciones correctas 
     * o HttpErrorResponse para peticiones fallidas
     */
    handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {

        return new Observable((observer: Observer<HttpEvent<any>>) => {

            let headers = new Headers();
            const keysHeaders = req.headers.keys();
            keysHeaders.forEach(name => {
                if (req.headers.has(name) && req.headers.get(name)) {
                    headers.append(name, req.headers.get(name)!);
                }
            });

            if (!req.headers.has('Accept')) {
                headers.append('Accept', 'application/json, text/plain, */*');
            }

            if (!req.headers.has('Content-Type')) {
                const detectedType = req.detectContentTypeHeader();
                if (detectedType !== null) {
                    headers.append('Content-Type', detectedType);
                }
            }

            const httpRequest = fetch(req.urlWithParams, {
                //retryOn: [503],
                headers: headers,
                body: req.serializeBody(),
                method: req.method,
                mode: "cors",
            })
                .then(async (response: any) => {
                    let { headers, status, statusText } = response;

                    const headersResponse = new HttpHeaders();

                    headers.forEach((value: any, name: any) => {
                        headersResponse.append(name, value);
                    });


                    let body: any = null;
                    let ok = status >= 200 && status < 300;

                    if (status !== HttpStatusCode.NoContent) {
                        let data = null;
                        try {
                            //validar segun tipo
                            if (req.responseType === 'json') {
                                data = await response.json();
                            } else {
                                data = await response.text();
                            }
                            body = data
                            
                        } catch (error) {
                            ok = false;
                            body = null;
                        }
                    }

                    if (status === 0) {
                        status = !!body ? HttpStatusCode.Ok : 0;
                    }

                    if (ok) {
                        observer.next(new HttpResponse({
                            body,
                            headers: headersResponse,
                            status,
                            statusText,
                            url: getValueProperty(response, 'url', undefined)
                        }));
                        observer.complete();
                    } else {
                        observer.error(new HttpErrorResponse({
                            error: body,
                            headers: headersResponse,
                            status,
                            statusText,
                            url: getValueProperty(response, 'url', undefined)
                        }));
                    }
                })
                .catch((error: any) => {
                    observer.error(new HttpErrorResponse({
                        error: error,
                        status: 0,
                        statusText: 'Unknown Error',
                        url: getValueProperty(req, 'url', undefined)
                    }));
                });
        })
    }
}
